export default {
  title: 'Configurações',
  subtitle: 'Conta, preferências e sessão.',
  profile: 'Perfil',
  name: 'Nome',
  email: 'E-mail',
  language: 'Idioma',
  language_hint: 'Usado na interface, em e-mails e notificações.',
  timezone: 'Fuso horário',
  saved: 'Preferências salvas.',
  sign_out: 'Sair',
  account_label: 'Conta',
  your_role: 'Seu papel',
  subscription: 'Assinatura',
  subscription_denied: 'Sem permissão para ver dados de assinatura.',
  plan: 'Plano',
  monthly: 'Mensalidade',
  state: 'Situação',
  renews_at: 'Renova em',
  subscription_empty: 'Nenhuma assinatura ativa nesta conta.',
  sign_out_confirm: 'Encerrar a sessão neste dispositivo?',
  financial: 'Resumo financeiro',
  financial_denied: 'Sem permissão para ver dados financeiros.',
  fin_paid_30d: 'Recebido (30 dias)',
  fin_open: 'Em aberto',
  fin_overdue: 'Vencido',
  fin_open_charges: 'Cobranças em aberto',
  fin_history: 'Histórico recente',
  fin_no_open: 'Nenhuma cobrança em aberto.',
  fin_empty: 'Nenhum lançamento ainda.',
  fin_col_due: 'Vencimento',
  fin_col_paid: 'Pago em',
  fin_col_method: 'Método',
  fin_col_amount: 'Valor',
  fin_col_kind: 'Origem',
  fin_kind_monthly: 'Mensalidade',
  fin_kind_charge: 'Cobrança avulsa',
  fin_refunded: 'Estornado',
}
